import { getCookie, deleteCookie, buildRequest } from "./auth.js";
import UnauthorisedError from '../errors/UnauthorisedError.js';

export async function fetchOutstandingSamples() {
    let url = `/FittingFrames/GetOutstandingSamples`;
    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Samples found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Samples: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchFrameTypes() {
    let url = `/FittingFrames/GetFrameTypeList`;
    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Frame Types found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Frame Types: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchFrameLists(frameType = 'All') {
    let url = `/FittingFrames/GetFramesList/${encodeURIComponent(frameType)}`;
    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 404) {
                console.warn('No Frames found for the given criteria.');
                return [];
            }
            else if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch Frames: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function createSample(sample) {
    const url = `/FittingFrames/CreateSample`;

    try {
        const response = await buildRequest(url, 'POST', sample);
        const text = await response.text();
        try {
            const data = JSON.parse(text);
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to create sample: ${response.status} ${response.statusText} | ${data.detail || text}`);
                }
            }
            return data;
        } catch (err) {
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to create sample: ${response.status} ${response.statusText} | ${text}`);
                }
            }
        }
    } catch (error) {
        throw new Error(error.message);
    }
}